module.exports = __webpack_public_path__ + "img/headerRibo.ff60f734.png";